import React from 'react'
import PropTypes from 'prop-types'
import Carousel from 'react-multi-carousel'
import { graphql, Link, useStaticQuery } from 'gatsby'
import moment from 'moment'
import '../css/_noveltiesCarousel.scss'

const NoveltiesCarousel = ({ title, novelties }) => {

  const data = useStaticQuery(graphql`
    query {
      allStrapiNovelties(sort: { fields: date, order: DESC }) {
        nodes {
          strapiId
          summary
          slug
          title
          id
          destacadoHome
          thumbnailName
          thumbnail {
            url
          }
          novelties_categories {
            id
          }
          date(formatString: "DD MMMM, YYYY", locale: "es")
          dateTo(formatString: "YYYY/MM/DD", locale: "es")
        }
      }
      allStrapiInstitution {
        nodes {
          ImageNoveltiesDefault {
            image {
              url
            }
          }
        }
      }
    }
  `)

  const { allStrapiNovelties: noveltiesAll } = data
  const { allStrapiInstitution: noveltiesDefault } = data

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1366 },
      items: 3
    },
    desktop: {
      breakpoint: { max: 1366, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 764 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 764, min: 0 },
      items: 1
    }
  }
  
  // Creando Array de todas las noticias que se deben mostrar con sus respectivos campos
  let noveltyAll = novelties.map((noveltie) => {
    for(const nov in noveltiesAll.nodes) {
      const novelty = noveltiesAll.nodes[nov]
      if (noveltie.novelty?.id === novelty.strapiId) {
        return noveltyConstructor(novelty, noveltie.destacado)
      }
    }
  })
  
  if (!novelties || novelties.length === 0 || noveltiesAll.length === 0 || noveltyAll.length === 0) return null;
  
  return (
    <div className="novelties-carousel-container container my-1">
      <div className="container mx-auto w-100 pb-4 px-0">
        {title &&
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="mb-0 novelties-title">
              {title}
            </div>
          </div>
        }
        <div id="novelties-carousel" className="mx-n2">
          <Carousel responsive={responsive}>
            {noveltyAll.map((noveltie) => {
              return (
                <div
                  className={`mb-4
                    ${noveltie.destacado
                      ? 'hightlighted'
                      : ''
                  }`}
                  key={`noveltiesNodesId-${noveltie.novelty.id}`}
                >
                  <div className={`h-100 d-flex rounded shadow-sm news-card overflow-hidden position-relative flex-column`}>
                    <div
                      className={`news-image`}
                      style={
                        noveltie.novelty?.thumbnail?.url
                          ? {
                              backgroundImage: `url(${noveltie.novelty?.thumbnail.url})`
                            }
                          : {
                              backgroundImage: `url(${noveltiesDefault.nodes[0].ImageNoveltiesDefault?.image.url})`
                            }
                      }
                      role="img"
                      alt={noveltie.novelty?.thumbnailName || ''}
                    ></div>
                    <div className="flex-grow-1 p-4 d-flex flex-column news-info">
                      <h6>
                        <small>
                          {moment(noveltie.novelty?.date)
                            .locale('es')
                            .format('DD-MM-YYYY')}
                        </small>
                      </h6>
                      
                      {/* Etiqueta de la noticia - novelties categories */}
                      {/* <div className="bg-sec px-2 py-1 text-white mb-2 fit-content">                            
                        {noveltiesCategory.nodes.map((category) => { 
                          return (noveltie.novelty.novelties_categories.map((noveltyCategory, i) => {
                            if (noveltyCategory === category.strapiId) {
                              if ((noveltie.novelty.novelties_categories.length - 1) > i) {
                                return category.name + " - "
                              } else {
                                return category.name
                              }
                            }
                          }))
                        })}
                      </div> */}

                      <h5 className="font-weight-bold">
                        {noveltie.title || noveltie.novelty?.title}
                      </h5>
                     
                      <div className="noticies-markdown">
                        <p>
                          {noveltie.novelty?.summary
                            ? noveltie.novelty.summary
                            : null}
                        </p>
                      </div> 

                      <Link
                        to={`/noticias/${
                          noveltie.slug || noveltie.novelty.slug
                        }`}
                        className={`btn btn-outline-info mt-auto fit-content text-uppercase rounded-pill px-4 font-secondary eventuality-button-font-size`}
                      >
                        VER MÁS
                      </Link>
                    </div>
                  </div>
                </div>
              )
            })}
          </Carousel>
        </div>
      </div>
    </div>
  )
}

// Construyendo estructura de las Noticias
const noveltyConstructor = (novelty, destacado = false) => {
  return ({
    id: novelty.id,
    destacado: destacado,
    novelty: {
      id: novelty.id,
      slug: novelty.slug,
      title: novelty.title,
      thumbnailName: novelty.thumbnailName,
      thumbnail: { url: novelty.thumbnail?.url },
      date: novelty.date,
      dateTo: novelty.dateTo,
      novelties_categories: novelty.novelties_categories?.map((categories) => categories.id),
      summary: novelty.summary
    }
  })
}

export default NoveltiesCarousel

NoveltiesCarousel.propTypes = {
  title: PropTypes.string,
  novelties: PropTypes.array.isRequired,
}